import { useQueryClient } from '@tanstack/react-query'
import TransitApiConfig from '../apiConfig'
import useTransitOperationInfoApi, {
  patchCompanyTransitOperationInfoNotesOrFeedback,
  patchTransitOperationInfoNotesOrFeedback,
  postTransitOperationInfo,
} from './api'
import { toNotesOrFeedbackTransitOperationInfoRequest } from './mapper'

const { getTransitOperationInfoByTransitOperationId } = TransitApiConfig.paths.transitOperationInfo.queryKeys

export default function useTransitOperationInfo(transitOperationId: number | null, isAdmin: boolean) {
  const queryClient = useQueryClient()
  const { getTransitOperationInfo } = useTransitOperationInfoApi(transitOperationId, isAdmin)

  const createTransitOperationInfo = async (id: number) => {
    if (id === null || id === undefined) throw new Error('Transit Operation ID cannot be null or undefined!')

    const created = await postTransitOperationInfo({
      transitOperationId: id,
    })
    await queryClient.invalidateQueries({ queryKey: getTransitOperationInfoByTransitOperationId(transitOperationId) })
    return created
  }

  const createOrUpdateNotesOrFeedback = async (id: number, notes: string) => {
    if (id === null || id === undefined) throw new Error('Transit Operation ID cannot be null or undefined!')

    const updated = await patchTransitOperationInfoNotesOrFeedback({
      id,
      data: toNotesOrFeedbackTransitOperationInfoRequest(notes),
    })
    await queryClient.invalidateQueries({ queryKey: getTransitOperationInfoByTransitOperationId(transitOperationId) })
    return updated
  }

  const createOrUpdateCompanyNotes = async (id: number, notes: string) => {
    if (id === null || id === undefined) throw new Error('Transit Operation ID cannot be null or undefined!')

    return patchCompanyTransitOperationInfoNotesOrFeedback({
      id,
      data: toNotesOrFeedbackTransitOperationInfoRequest(notes),
    })
  }

  return {
    getTransitOperationInfo,
    createTransitOperationInfo,
    createOrUpdateNotesOrFeedback,
    createOrUpdateCompanyNotes,
  }
}
